import { Pipe, PipeTransform } from '@angular/core';
import { get } from 'lodash';
import { defaultLang } from '../../constants';
@Pipe({ name: 'i18n_label' })
export class TranslateLabelPipe implements PipeTransform {
  userLang = navigator.language.toString().toLocaleLowerCase();
  transform(value: any): string {
    try {
      return get(value, `${this.userLang}`, get(value, `${defaultLang}`, value));
    } catch {
      return '';
    }
  }
}